import { idtype } from "querypieces";

export default `
...on pageBuilder_localeNav_BlockType {
	${idtype}
}
`